



































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import VueRouter from "vue-router";
import { Validator } from "vee-validate";
import FileUpload from "vue-upload-component";
import { useNotifierStore } from "@/shared/store/notifier";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";

@Component({
  components: {
    FileUpload
  }
})
export default class PartnerLogoUpload extends Vue {
  $router: VueRouter;
  $validator: Validator;

  notifierStore = useNotifierStore();
  portalCustomization = usePortalCustomizationStore();
  file = null;
  isSubmitting = false;
  accept = ".png,.svg";

  @Prop() partnerId: number;

  mounted () {
    this.portalCustomization.getCustomDebitCardImage(this.partnerId);
    this.initialize();
  }

  @Watch("portalCustomization.isDebitCardLoaded")
  initialize () {
    if (this.portalCustomization.debitCardImageSrc && this.$refs.debitcardimage) {
      (this.$refs.debitcardimage as any).src = this.portalCustomization.debitCardImageSrc;
    }
  }

  fileDebitCardChange (file) {
    if (!file) return;
    this.file = (document.getElementById("debit-card-asset") as any).files[0];
    const f = new FileReader();
    f.onload = () => (this.$refs.debitcardimage as any).src = f.result;
    f.readAsDataURL(this.file);
  }

  deleteAsset (): void {
    this.isSubmitting = true;

    this.portalCustomization.deleteDebitCardImage(this.partnerId)
        .then(resp => {
          this.$nextTick(() => {
            this.notifierStore.setSuccess("Partner asset deleted", this.notifierStore.shortTimeout);
            this.isSubmitting = false;
            this.initialize();
          });
        })
        .catch(() => {
          this.isSubmitting = false;
          this.notifierStore.setDanger("Could not delete partner debit card image", this.notifierStore.shortTimeout);
        });
  }

  get submitDisabled () {
    return this.isSubmitting;
  }

  submit () {
    if (!this.file) return;
    if (this.isSubmitting) return;

    this.isSubmitting = true;

    this.portalCustomization.saveCustomDebitCardImage({
          partnerId: this.partnerId,
          logoFile: this.file
        })
        .then(resp => {
          this.$nextTick(() => {
            this.notifierStore.setSuccess("partner support info saved", this.notifierStore.shortTimeout);
            this.isSubmitting = false;
            this.initialize();
          });
        })
        .catch(() => {
          this.isSubmitting = false;
          this.notifierStore.setDanger("Could not save partner debit card image", this.notifierStore.shortTimeout);
        });
  }

}
